import { Check } from "lucide-react";

const STAGES = [
  { key: "intake", label: "Intake" },
  { key: "document_preparation", label: "Document Preparation" },
  { key: "filing", label: "Filing" },
  { key: "hearing_preparation", label: "Hearing Preparation" },
  { key: "completion", label: "Completion" },
];

// State for a given stage row, relative to the current stage index.
function getStageState(stageIndex, currentIndex) {
  if (stageIndex < currentIndex) return "done";
  if (stageIndex === currentIndex) return "active";
  return "todo";
}

// Class lookups — replace nested ternaries with a flat map.
const DESKTOP_CIRCLE = {
  done: "bg-blue-700 border-amber-400 text-white",
  active: "bg-zinc-950 border-amber-400 text-amber-400",
  todo: "bg-zinc-950 border-zinc-700 text-zinc-500",
};

const DESKTOP_LABEL = {
  done: "text-zinc-200",
  active: "text-amber-400 font-semibold",
  todo: "text-zinc-500",
};

const MOBILE_CIRCLE = {
  done: "bg-blue-700 border-amber-400 text-white",
  active: "border-amber-400 text-amber-400",
  todo: "border-zinc-700 text-zinc-500",
};

const MOBILE_LABEL = {
  done: "text-zinc-200",
  active: "text-amber-400 font-semibold",
  todo: "text-zinc-500",
};

export default function CaseStageTracker({ stage = "intake" }) {
  const currentIndex = Math.max(0, STAGES.findIndex((s) => s.key === stage));

  return (
    <div className="w-full" data-testid="case-stage-tracker">
      {/* Desktop / tablet: horizontal stepper */}
      <div className="hidden sm:flex items-center w-full">
        {STAGES.map((s, i) => {
          const state = getStageState(i, currentIndex);
          const done = state === "done";
          return (
            <div key={s.key} className="flex items-center flex-1 last:flex-none" data-testid={`stage-${s.key}`}>
              <div className="flex flex-col items-center text-center flex-1">
                <div
                  className={`h-9 w-9 rounded-full border flex items-center justify-center transition-colors ${DESKTOP_CIRCLE[state]}`}
                >
                  {done ? <Check className="h-4 w-4" strokeWidth={2.5} /> : <span className="font-mono text-xs">{i + 1}</span>}
                </div>
                <p className={`text-xs mt-3 max-w-[120px] leading-tight ${DESKTOP_LABEL[state]}`}>
                  {s.label}
                </p>
              </div>
              {i < STAGES.length - 1 && (
                <div className={`h-px flex-1 -mt-9 ${done ? "bg-blue-700" : "bg-zinc-800"}`} />
              )}
            </div>
          );
        })}
      </div>

      {/* Mobile: vertical list */}
      <div className="sm:hidden space-y-3">
        {STAGES.map((s, i) => {
          const state = getStageState(i, currentIndex);
          const done = state === "done";
          return (
            <div key={s.key} className="flex items-center gap-3" data-testid={`stage-mobile-${s.key}`}>
              <div className={`h-8 w-8 rounded-full border flex items-center justify-center flex-shrink-0 ${MOBILE_CIRCLE[state]}`}>
                {done ? <Check className="h-4 w-4" strokeWidth={2.5} /> : <span className="font-mono text-xs">{i + 1}</span>}
              </div>
              <p className={`text-sm ${MOBILE_LABEL[state]}`}>
                {s.label}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export { STAGES };
